// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__flexIt___HBKtg {
  display: flex;
  align-items: center;
}
.styles__productCol___W0Gah {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eee;
}
.styles__productRow___EIUem {
  display: flex;
  margin-bottom: 5px;
  flex-direction: row;
}
@media (min-width: 991px) {
  .styles__productRow___EIUem {
    height: 118px;
  }
}
@media (max-width: 991px) {
  .styles__productRow___EIUem {
    flex-direction: column;
  }
}
.styles__productDescription___HGCeO {
  flex-direction: column;
  align-items: flex-start;
}
.styles__cartItemLink___pFPFD {
  justify-content: space-between;
  padding: 5px 0;
  overflow: hidden;
  text-decoration: none !important;
  color: #333333 !important;
  width: 100%;
}
.styles__cartItemImg___hdnUs {
  height: 36px;
  width: 36px;
  float: left;
  margin-right: 10px;
}
.styles__autoProductSuffix___oOSOf {
  color: #888;
  font-size: 12px;
  display: block;
}
.styles__productTitle___j69a_ {
  font-weight: 400;
  font-size: 18px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}
.styles__flexSpaceBetween___ZxLOg {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.styles__priceCol___kzSbc {
  justify-content: space-between;
  flex-direction: row;
}
.styles__price___IAYB_ {
  font-size: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/CheckoutComponent/UnselectedAutoproductItem/styles.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;AADF;AAIA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAFF;AAKA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;AAHF;AAIE;EAAA;IACE,aAAA;EADF;AACF;AAEE;EAAA;IACE,sBAAA;EACF;AACF;AAEA;EAEE,sBAAA;EACA,uBAAA;AAAF;AAGA;EAEE,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;EACA,WAAA;AADF;AAIA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAFF;AAKA;EACE,WAAA;EACA,eAAA;EACA,cAAA;AAHF;AAMA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AAJF;AAOA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AALF;AAQA;EAEE,8BAAA;EACA,mBAAA;AANF;AASA;EACE,eAAA;AAPF","sourcesContent":["@import '../../../../shared/variables.less';\n\n.flexIt {\n  display: flex;\n  align-items: center;\n}\n\n.productCol {\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #eee;\n}\n\n.productRow {\n  display: flex;\n  margin-bottom: 5px;\n  flex-direction: row;\n  @media (min-width: 991px) {\n    height: 118px;\n  }\n  @media (max-width: 991px) {\n    flex-direction: column;\n  }\n}\n\n.productDescription {\n  composes: flexIt;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.cartItemLink {\n  composes: flexIt;\n  justify-content: space-between;\n  padding: 5px 0;\n  overflow: hidden;\n  text-decoration: none !important;\n  color: @eon-text-color-light !important;\n  width: 100%;\n}\n\n.cartItemImg {\n  height: 36px;\n  width: 36px;\n  float: left;\n  margin-right: 10px;\n}\n\n.autoProductSuffix {\n  color: #888;\n  font-size: 12px;\n  display: block;\n}\n\n.productTitle {\n  font-weight: 400;\n  font-size: 18px;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.flexSpaceBetween {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}  \n\n.priceCol {\n  composes: productCol;\n  justify-content: space-between;\n  flex-direction: row;\n}\n\n.price {\n  font-size: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexIt": `styles__flexIt___HBKtg`,
	"productCol": `styles__productCol___W0Gah`,
	"productRow": `styles__productRow___EIUem`,
	"productDescription": `styles__productDescription___HGCeO styles__flexIt___HBKtg`,
	"cartItemLink": `styles__cartItemLink___pFPFD styles__flexIt___HBKtg`,
	"cartItemImg": `styles__cartItemImg___hdnUs`,
	"autoProductSuffix": `styles__autoProductSuffix___oOSOf`,
	"productTitle": `styles__productTitle___j69a_`,
	"flexSpaceBetween": `styles__flexSpaceBetween___ZxLOg`,
	"priceCol": `styles__priceCol___kzSbc styles__productCol___W0Gah`,
	"price": `styles__price___IAYB_`
};
export default ___CSS_LOADER_EXPORT___;
